import { Tag, Tooltip, Typography } from 'antd';

const { Text } = Typography;

/** Distinct colours so a reviewer reads the plant at a glance, not by word. */
const SITE_COLOR: Record<string, string> = {
	'West Bend': 'geekblue',
	Cedarburg: 'purple',
};

/**
 * Which plant a bar was bought for.
 *
 * The queue mixes both sites, and a certificate landing on the wrong plant's
 * bar is the kind of mistake nobody notices later, so the site travels with
 * the heat rather than being something you work out from the PO. It comes from
 * the ERP material order, which is where receiving reads it from too.
 */
export default function SiteTag({
	name,
	compact = false,
}: {
	name: string;
	compact?: boolean;
}) {
	if (!name) {
		return compact ? (
			<Text type="secondary">—</Text>
		) : (
			<Tooltip title="No ERP purchase order has matched yet, so the plant is unknown.">
				<Tag>Site unknown</Tag>
			</Tooltip>
		);
	}
	return (
		<Tag color={SITE_COLOR[name] ?? 'default'} style={{ marginInlineEnd: 0 }}>
			{name}
		</Tag>
	);
}
